import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { generateRows } from "./utils";
import InputText from "../../components/inputField/InputText";
import { updateRoomRate } from "./api";
import { useToastrContext } from "../../components/Provider/ToastrProvider";
import { UPDATE_MSG } from "../../constant";
import PermissionGuard from "../../components/common/PermissionGuard";

const BulkRoomRate = ({ hotelDetails, dateRange, contractType }) => {
  const [data, setData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { errorResponseHandler } = useToastrContext();

  const handleChangeAmount = (roomId, ratePlanId, key, newAmount, idx) => {
    setData((prevData) =>
      prevData.map((room) =>
        room.roomId === roomId
          ? {
            ...room,
            ratePlan: room.ratePlan.map((ratePlan) =>
              ratePlan.ratePlanId === ratePlanId
                ? {
                  ...ratePlan,
                  ...(key === "paidChildFiveToTwelve" ||
                    key === "extraAdultAmount"
                    ? { [key]: newAmount }
                    : {
                      adultRates: ratePlan.adultRates.map((rate, index) =>
                        idx !== undefined && index === idx
                          ? { ...rate, amount: newAmount }
                          : rate
                      ),
                    }),
                }
                : ratePlan
            ),
          }
          : room
      )
    );
  };

  useEffect(() => {
    if (Object.keys(hotelDetails)?.length === 0) return;
    setData(
      hotelDetails?.room?.map((row) => ({
        hotelId: hotelDetails?.id,
        name: row?.roomName,
        baseAdults: row.baseAdults,
        roomId: row.id,
        ratePlan: row.taggedRatePlan.map((rates) => ({
          roomId: rates.roomId,
          ratePlanId: rates.ratePlanId,
          ratePlanName: rates.ratePlan.name,
          paidChildFiveToTwelve: "",
          extraAdultAmount: "",
          adultRates: generateRows(row.baseAdults),
        })),
      }))
    );
  }, [hotelDetails]);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      const payload = {
        ...dateRange,
        contract: contractType,
        hotelId: hotelDetails?.id,
        data: data,
      };

      const response = await updateRoomRate(payload);

      if ([200, 201]?.includes(response?.status)) {
        errorResponseHandler(UPDATE_MSG, "success");
      }
    } catch (error) {
      errorResponseHandler(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <div className="form-body">
        <Accordion className="accordion accordion-primary" defaultActiveKey="0">
          {data.map((d, i) => (
            <Accordion.Item
              className="accordion-item"
              key={i}
              eventKey={`${i}`}
            >
              <Accordion.Header className="accordion-header rounded-lg">
                {d.name}
              </Accordion.Header>
              <Accordion.Collapse eventKey={`${i}`}>
                <div className="accordion-body">
                  {d.ratePlan?.map((ratePlan, index) => (
                    <div key={index}>
                      <div className="sub-menu-title">
                        {ratePlan?.ratePlanName}
                      </div>
                      <div className="row">
                        {ratePlan.adultRates?.map((adults, idx) => (
                          <div
                            key={`${ratePlan?.ratePlanName + d.name + idx}`}
                            className={`form-group mb-3 col-sm-4 col-md-4`}
                            style={{ display: "flex", gap: "10px" }}
                          >
                            <div
                              style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                padding: "5px 10px",
                              }}
                            >
                              <div>
                                <span>{adults.adult}</span>
                                <i
                                  className="fa fa-user"
                                  style={{ marginLeft: "3px" }}
                                ></i>
                              </div>
                              <span>Base</span>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                padding: "5px 10px",
                              }}
                            >
                              <InputText
                                placeholder="Enter"
                                type="number"
                                value={adults.amount}
                                style={{ border: 0 }}
                                onChange={(e) => {
                                  const newAmount = e.target.value;
                                  handleChangeAmount(
                                    ratePlan.roomId,
                                    ratePlan.ratePlanId,
                                    adults.adult,
                                    newAmount,
                                    idx
                                  );
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="row">
                        <div className="form-group mb-3 col-sm-4 col-md-4">
                          <label>Free Child Rate (0 - 4 years)</label>
                          <InputText
                            placeholder="Enter"
                            value="Free"
                            disabled
                            style={{
                              backgroundColor: "#808080",
                              color: "#FFFFFF",
                            }}
                          />
                        </div>
                        <div className="form-group mb-3 col-sm-4 col-md-4">
                          <label>Paid Child Rate (5 - 12 years)</label>
                          <InputText
                            placeholder="Enter"
                            type="number"
                            value={ratePlan.paidChildFiveToTwelve}
                            onChange={(e) => {
                              const newAmount = e.target.value;
                              handleChangeAmount(
                                d.roomId,
                                ratePlan.ratePlanId,
                                "paidChildFiveToTwelve",
                                newAmount,
                                index
                              );
                            }}
                          />
                        </div>
                        <div className="form-group mb-3 col-sm-4 col-md-4">
                          <label>Extra Adult Charge (13 years and above)</label>
                          <InputText
                            placeholder="Enter"
                            type="number"
                            value={ratePlan.extraAdultAmount}
                            onChange={(e) => {
                              const newAmount = e.target.value;
                              handleChangeAmount(
                                d.roomId,
                                ratePlan.ratePlanId,
                                "extraAdultAmount",
                                newAmount,
                                index
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Accordion.Collapse>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
      <PermissionGuard permissions={["rate:edit"]}>
        <button
          onClick={handleSubmit}
          className="btn btn-primary"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Processing...
            </>
          ) : (
            "Submit"
          )}
        </button>
      </PermissionGuard>
    </div>
  );
};

export default BulkRoomRate;
